module.exports = "<sc-audio-waves ng-if=\"$ctrl.isWaves == '1'\" fact=\"$ctrl.fact\" src=\"$ctrl.src\"></sc-audio-waves><sc-audio-file ng-if=\"$ctrl.isWaves == '2'\" fact=\"$ctrl.fact\" src=\"$ctrl.src\"></sc-audio-file><div ng-if=\"$ctrl.isWaves == '0'\" style=\"width:100%;text-align:center\"><i class=\"icon-loading animate-spin\"></i></div>"


//////////////////
// WEBPACK FOOTER
// ./src/facts/audio-waves/audio-viewer.component.html
// module id = 357
// module chunks = 0